import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { startLogin, userSetType, userSetUsername } from '../../actions/auth';
import { formValidation } from '../../helpers/formValidation';
import { useForm } from '../../hooks/useForm';
import { TextField } from '../../helpers/FormControlRSuit';
import { MaskedInputPhone } from '../../helpers/maskFormControl';
import 'animate.css';
import { Form } from 'rsuite';

export const LoginForm = ({viewForm}) => {
    const dispatch = useDispatch();
    const {loginForm} = useSelector(state => state.forms);
    const [visiblePassword, setVisiblePassword] = useState(false);
    const [formError, setFormError] = useState({});
    const [form, setform] = useState({});
    const {type, username: userSaved} = useSelector(state => state.auth);
    
    const [formValue, setFormValue] = useState({
        username: userSaved,
        password: '',
        rememberMe: false,
    });
    const [{username, password, rememberMe}, handleInputChange, reset] = useForm({
        username: userSaved,
        password: '',
        rememberMe: false,
    })

    // useEffect(() => {
    //     document.querySelector('form').classList.remove('animate__fadeIn')
    //     return () => {
    //         document.querySelector('form').classList.add('animate__fadeIn')
    //     }
    // }, []);

    const handleClear = async (e) => {
        e.preventDefault();
        dispatch(userSetType('user'));
        dispatch(userSetUsername(''));
        reset();
    }

    const history = useHistory();

    const handleSubmit= async (e)=>{
        const resp = await dispatch(startLogin(formValue.username, formValue.password, formValue.rememberMe, 'loginForm'));
        if(resp){
            const lastPath = localStorage.getItem('lastPath');
            history.replace(lastPath);
        }
    }

    return (
        <Form
                fluid
                ref={ref => (setform(ref))}
                onChange={formValue => {
                  setFormValue(formValue);
                }}
                onCheck={formError => {
                  setFormError(formError);
                }}
                formValue={formValue}
            name="loginForm"
            className="animate__animated animate__fadeIn" 
            onSubmit={handleSubmit}
            noValidate
        >
            {
                !!loginForm.msg &&
                    <div className={`alert alert-${loginForm.error?'danger':'success'}`} role="alert">
                        {loginForm.msg}
                    </div>
            }
            <div className="form-group buttonIn">
                {/* <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Folio ó Correo electrónico"
                    disabled={ type !== 'user' ? true : false}
                    autoFocus={ type === 'user' ? true : false}
                    name="username"
                    value={formValue.username}
                    onChange={(e) => {
                        setFormValue({
                            ...formValue,
                            username: e.target.value
                        })
                    }}
                    required
                /> */}

                <TextField
                    autoFocus={ type === 'user' ? true : false}
                    className="form-control"
                    disabled={ type !== 'user' ? true : false}
                    label="Celular"
                    name="username"
                    accepter={MaskedInputPhone}
                    required
                />
                {
                    username && 
                        <a href="/" className="floatButton" onClick={handleClear} style={{top: 25}}>
                            <i className="fas fa-times"></i>
                        </a> 
                }
                <div className="invalid-feedback">
                    Es necesario tu numero de folio o tu correo electrónico.
                </div>
                
            </div>
            {
                type === 'password' &&
                    <div className="form-group animate__animated animate__fadeIn">
                        {/* <input 
                            type="password" 
                            className="form-control" 
                            id="password" 
                            placeholder="Contraseña" 
                            autoFocus={ type === 'password' ? true : false}
                            name="password"
                            value={password}
                            onChange={handleInputChange}
                            required
                        /> */}
                        <div className="form-group buttonIn">
                            <TextField
                                autoFocus={ type === 'password' ? true : false}
                                className="form-control"
                                name="password"
                                type={visiblePassword ? 'text' : 'password'}
                                required
                            />
                            <a href="#" className="floatButton" onClick={(e) => {
                                e.preventDefault();
                                setVisiblePassword(!visiblePassword)}
                                }>
                                <i className={visiblePassword ? 'fas fa-eye' : 'fas fa-eye-slash'}></i>
                            </a> 
                        </div>
                        <div className="invalid-feedback">
                            Es necesario tu contraseña.
                        </div>
                    </div>
            }
            <button 
                type="submit" 
                className="btn btn-primary btn-block btn-submit" 
                disabled={!!loginForm.loading ? true : false}
            >
                {!!loginForm.loading && <i className="spinner-border spinner-border-sm" role="status"></i>} Entrar
            </button>
            {
                type === 'password' &&
                    <div className="auth-options">
                        <div className="custom-control custom-checkbox form-group">
                            <input 
                                type="checkbox" 
                                className="custom-control-input" 
                                id="exampleCheck1"
                                name="rememberMe"
                                value={true}
                                checked={rememberMe}
                                onChange={handleInputChange}
                            />
                            <label className="custom-control-label" htmlFor="exampleCheck1">
                                Recordarme 
                            </label> <i className="fas fa-question-circle" data-toggle="tooltip" data-html="true" title="" data-original-title="Al seleccionar &quot;Recordarme&quot;, se reduce la cantidad de veces que se le solicita que inicie sesión en este dispositivo.<br>Para mantener su cuenta segura, use esta opción <strong>unicamente en sus dispositivos personales</strong>."></i>
                        </div>
                        <a href="./" className="forgot-link" onClick={viewForm}>
                            Olvidaste tu contraseña?
                        </a>
                    </div>
            }
        </Form>
    )
}
